import theme from "@/styles/theme";
import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${theme.colors.palete.brownLight};
  border-radius: 8px;
  background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  width: 180px;
  height: 150px;
  @media (${theme.devices.tablet}) {
    width: 160px;
  }
  .data {
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    .title {
      font-size: 1.2rem;
      font-weight: bold;
      color: ${theme.colors.palete.brownDark};
      text-align: center;
    }
    .description {
      font-size: 1rem;
      color: ${theme.colors.palete.brownDark};
      text-align: center;
    }
  }
`;
